import { render, staticRenderFns } from "./M-game.vue?vue&type=template&id=57a45018&scoped=true&"
import script from "./M-game.vue?vue&type=script&lang=js&"
export * from "./M-game.vue?vue&type=script&lang=js&"
import style0 from "./M-game.vue?vue&type=style&index=0&id=57a45018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a45018",
  null
  
)

export default component.exports